// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const modalStyles = css`
  div.TCPModal__InnerContent.atb-innerContent {
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    ${(props) =>
      `
    padding: 0;
    width: 100%;
    @media ${props.theme.mediaQuery.smallOnly} {
      animation: slide-in-mobile 0.5s forwards;
      border-radius: ${props.theme.spacing.ELEM_SPACING.XS}
        ${props.theme.spacing.ELEM_SPACING.XS} 0px 0px;
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }
    `}
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 350px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 375px;
    }

    &.hide-added-to-bag-content {
      display: none !important;
    }

    .Modal-Header {
      ${(props) =>
        `
      background-color: ${props.theme.colorPalette.gray[300]};
      `}
    }

    .Modal_Heading {
      font-size: 16px;
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      font-weight: ${(props) => props.theme.fonts.fontWeight.semibold};
      line-height: 43px;
      border: none;
      margin-bottom: 0;
      padding: 0;
      display: inline;
      ${(props) =>
        `
      line-height: 46px;
      margin-left: 20px;
      @media ${props.theme.mediaQuery.medium} {
        margin-left: ${props.isNewATBProductInformationDesignEnabled ? '35%' : '40px'};
      }
      `}

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) => props.isAddedToBagRedesignEnabled && `margin-left: 37%;`}
      }

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) => props.isBackToQuickViewButtonShow && `margin-left: calc(37% - 49px);`}
      }
    }

    .close-modal {
      right: 18px;
      top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      ${(props) =>
        `
           @media ${props.theme.mediaQuery.smallOnly} {
            padding: 33px 7px 13px 40px;
            right: 0px;
            top: 0px;
            background-position: 45% 58%;
            background-size: auto;
          }`}
    }
    .blurred-content {
      filter: blur(4px);
      -o-filter: blur(4px);
      -ms-filter: blur(4px);
      -moz-filter: blur(4px);
      -webkit-filter: blur(4px);
    }

    .fbt-wrapper {
      overflow: hidden;
      opacity: 1;
    }

    .fbt-wrapper > div {
      margin-top: 0;
    }

    .fbt-complete {
      min-height: 0;
      height: 0;
      transition: height 1.2s ease;
      overflow: hidden;
      opacity: 0;
    }
    .error-notification {
      background-color: ${(props) => props.theme.colorPalette.gray[300]};
      margin-top: -16px;
    }
    .new-error-container {
      background: ${(props) => props.theme.colorPalette.gray[300]};
      padding: 12px;
    }

    .error-header-arrow-container {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
    }
    .toggle-arrow {
      background: none;
      border: none;
      cursor: pointer;
      color: ${(props) => props.theme.colorPalette.gray[1600]};
      padding: 0px;
    }
    .error-subheader-container.expanded {
      max-height: 200px;
      opacity: 1;
    }

    .error-subheader-container.collapsed {
      max-height: 0;
      opacity: 0;
    }
    .error-subheader-container {
      overflow: hidden;
      max-height: 0;
      opacity: 0;
      transition: max-height 0.3s ease, opacity 0.3s ease;
    }
    .new-error-inner-container {
      padding: 12px;
      border: ${(props) =>
        props.isInventoryUnavailable
          ? `0px solid ${props.theme.colors.NOTIFICATION.ERROR}`
          : `1px solid ${props.theme.colors.NOTIFICATION.ERROR}`};
      border-radius: 10px;
      border-left-width: ${(props) => (props.isInventoryUnavailable ? '6px' : '3px')};
      background: white;
    }
    .unavailable-product-image {
      width: 36px;
      height: 42px;
      margin-right: 8px;
    }
    .error-text-msg {
      margin-bottom: 6px;
      line-height: 18px;
    }
  }
`;

export const productInfoStyles = css`
  margin-bottom: 10px;
  .product {
    margin: 0;
    width: 100%;
  }
`;

export const pointsInfoStyles = css`
  .row-padding {
    margin: 0;
    width: 100%;
  }
  .divided-line {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
`;

export const buttonActionStyles = css`
  .view-bag-container {
    margin: 0;
    width: 100%;
  }
  .checkout-button {
    margin: 0;
    width: 100%;
  }
`;

export const LoyaltyWrapperStyles = css`
  .loyalty-banner-wrapper {
    padding: 0;
    margin-bottom: ${(props) => (props.aboveCta ? `12px` : 0)};
  }
`;

export const recommendationStyles = css`
  .recommendations-header {
    width: auto;
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.BLACK};
    margin: 0px auto ${(props) => props.theme.spacing.ELEM_SPACING.XS_6} 7px;
    padding-top: 0;
  }
  .item-container-inner {
    box-sizing: border-box;
    width: 125px;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0 8px 4px;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 0 8px 4px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      width: 104px;
      padding: 0 8px 4px;
    }

    ${(props) =>
      `
      border: solid 1px ${props.theme.colorPalette.gray[500]};
      padding: 0 8px 4px;
      margin-right: 8px;
      border-radius: 6px;
      height: 100%;
      overflow: hidden;
    `}
  }

  .custom-ranking-container img {
    width: 71px;
    height: 14px;
  }

  .custom-ranking-container .reviews-count {
    margin-top: 0px;
    font-size: 10px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 3px;
      font-size: 10px;
    }
  }

  .ranking-wrapper {
    white-space: pre;
    word-wrap: normal;
  }

  .product-list {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      max-width: 133px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .recommendations-container {
      margin-left: -5px;
    }
    .product-image-container {
      height: 150px !important;
    }
    .smooth-scroll-list-item {
      margin-right: 0px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .product-image-container {
      height: auto;
    }
    .smooth-scroll-list-item {
      margin-right: 0px;
    }
  }

  .container-price > p {
    font-size: ${(props) => props.theme.typography.fontSizes.fs15};
    width: 40px;
    height: 20px;
    margin: 0 2px -3px 0;
    font-family: Nunito;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .container-price > span {
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
  }
  && .custom-ranking-container img {
    width: 60px;
    height: 12px;
    min-width: 60px;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 63px;
      height: 13px;
      min-width: 63px;
    }
  }
  && .product-image-container > a {
    min-height: 130px;
  }
  && .slick-list {
    margin-right: -20%;
    margin-left: -8%;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: -8%;
    }
  }
  && .recommendations-tile .slick-arrow {
    top: 35%;
  }
  && .slick-prev {
    top: 28%;
    margin-left: 15%;

    background-image: none;
    width: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.SM};
    height: 72px;
    opacity: 0.79;
    padding: 27px 5px 27px 7px;
    background-color: ${(props) => props.theme.colors.WHITE};
    border-top-right-radius: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XXS};
    border-bottom-right-radius: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XXS};
  }
  && .slick-prev::after {
    content: '';
    border: solid black;
    border-width: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 0;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    transform: rotate(135deg);
    margin: 4px 0;
  }
  && .slick-next {
    top: 28%;
    margin-right: 15%;

    background-image: none;
    width: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.SM};
    height: 72px;
    opacity: 0.79;
    padding: 27px 5px 27px 7px;
    background-color: ${(props) => props.theme.colors.WHITE};
    border-top-left-radius: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XXS};
    border-bottom-left-radius: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XXS};
  }
  && .slick-next::after {
    content: '';
    border: solid black;
    border-width: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 0;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    transform: rotate(-45deg);
    background: none;
    margin: 4px 0;
  }
  && .product-list {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }
`;

const styles = css`
  .newAddtobag-wrapper {
    .smooth-scroll-list {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      width: 100%;
      -ms-overflow-style: none;
      height: 100%;
      ${(props) => props.isVerticalRecommendationsEnabled && `display:flex;flex-direction:column; `}
    }
    .smooth-scroll-list::-webkit-scrollbar {
      display: none;
    }
    .smooth-scroll-list-item {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      width: 80%;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) => props.isNewPDPEnabled && `margin-right: 0px`}
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        ${(props) => props.isNewPDPEnabled && `padding-left: 4px;`}
      }
    }
    .smooth-scroll-list-item:first-child {
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        ${(props) => props.isNewPDPEnabled && `padding-left: 30px;`}
      }
    }
  }
  .added-to-bg-close {
    top: 21px;
  }
  .addedToBagWrapper {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100% - 43px);
    padding-right: 15px;
    margin-left: -17px;
    padding-left: 17px;
  }
  .continue-shopping {
    width: 343px;
    height: 16px;
    margin: 0 0 30px 1px;
    font-family: Nunito;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: ${(props) => props.theme.colors.BLACK};
  }
  .recommendationWrapper {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0px;
    }
  }
  .loyaltyAddedToBagWrapper {
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    ${(props) =>
      props.isAddedToBagRedesignEnabled &&
      `
    padding-bottom:0px;
    width: 96%;
    `}
  }
  .style-with-wrapper {
    position: relative;
    padding-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.LRG};
  }
  .new-added-to-bag-modal {
    margin: 0;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    height: auto;
    position: relative;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      max-height: 75vh;
    }
  }
  .recommendation-caro {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-bottom: 90px;
    }
  }
  ${(props) =>
    props.isAddedToBagRedesignEnabled
      ? `
  .ATBRedesign{
    padding-top: 16px;
  }
  .newAddtobag-wrapper {
    width: calc(100% + 16px);
    margin-left: -15px;
    padding-left: 15px;
    margin-top: -16px;
    margin-bottom: 15px;
    padding-top: 16px;
    padding-bottom: 12px;
    border-top: solid 1px ${props.theme.colorPalette.gray[500]};
    background-color: ${props.theme.colorPalette.gray[300]};
    min-height:  ${props.isNewATBProductInformationDesignEnabled ? '120px' : '150px'};
  }
  .product-price {
    font-size: ${props.theme.typography.fontSizes.fs16};
    font-weight: ${props.theme.fonts.fontWeight.extrabold};
    color: ${props.theme.colorPalette.red[500]};
    margin-top: 8px;
  }
  .sub-total {
    display: flex;
    width: 96%;
    @media ${props.theme.mediaQuery.smallOnly} {
      width: 96%;
    }
  }
  .add-to-bag-subtotal-redesign {
    font-weight:  ${
      props.isNewATBProductInformationDesignEnabled
        ? props.theme.fonts.fontWeight.semiBold
        : props.theme.fonts.fontWeight.normal
    };
  }

  .added-to-bag-multi-item-style {
    .tile-equal-height {
      display: flex !important;
      height: 100%;
    }
    .slick-track {
      display:flex;
      width: 100% !important;
    }
    .slick-slide {
      display:flex;
      height: auto;
      width: 100% !important;
    }
    .slick-prev {
      left: -9px;
      top: 45%;
      height: 60px;
      width: 44px;
    }
    .slick-next {
      right: 7px;
      top: 45%;
      height: 60px;
      width: 44px;
    }
  }

  .added-to-bag-multi-item {
    .tile-equal-height {
      display: flex !important;
      height: 100%;
    }
    .slick-track {
      display:flex;
    }
    .slick-slide {
      display:flex;
      height: auto;
    }
    .slick-prev {
      left: -9px;
      top: 45%;
      height: 60px;
      width: 44px;
    }
    .slick-next {
      right: 7px;
      top: 45%;
      height: 60px;
      width: 44px;
    }
  `
      : ''}
`;

export const customStyles = css`
  .spinner-overlay {
    position: absolute;
  }
`;

export default styles;
